import { Injectable } from '@angular/core';

import { Http } from '@angular/http';

import { UserData } from '../../providers/user-data';
import { CommonData } from '../../providers/common-data';
import { NativeScriptHttpModule } from "nativescript-angular/http";
import { KontrollenModel } from './kontrollen-model';
import { ToastController } from 'ionic-angular';
import moment from 'moment';
import { unescapeHtml } from '@angular/platform-browser/src/browser/transfer_state';

declare var FileTransfer : any;  

@Injectable()
export class KontrollenData {
  data: any;
  searchdata: any;
  kont: KontrollenModel;
  actkontrolleuecount: number;
  aBeweise: any[];

  lppicture: any;

  updateRequired:boolean;

  constructor(public http: Http
            , public common: CommonData
            , public userData: UserData
            , public toastCtrl: ToastController
            ) {
              this.aBeweise = [];              
            }

  createKont(grundstueck_id, longit, latit){
    this.aBeweise.length = 0;
    this.actkontrolleuecount = 0;
    this.kont = new KontrollenModel();
    this.kont.fkuser = this.userData.userid;
    this.kont.fkgrund = grundstueck_id;
    this.kont.start = moment().format();
    this.kont.startlatit = latit;
    this.kont.startlongit = longit;
    
    return new Promise(resolve => {
      let params = JSON.stringify({kont:this.kont, token: this.userData.jwt});    

      this.http.post(this.common.baseurl+'kontrollen/createnew',params)
        .subscribe(data => {
          let response = data.json();
          //console.log(response);
          this.updateRequired = true;

          if(response.success === true){
              this.kont.kontid = response.data.kontid;
              this.kont.additionalinfos = response.data.additionalinfos;
              resolve(true);
          }
          else{  
            this.kont.error = response.message;
            resolve(false);  
            
          }
        //resolve([this.data]);          
        }, error => {
          resolve(false);  
      });
    });    
  }
  public manualDateOverride(manualdate) {
    //console.log(manualdate);
    for(let i=0; i<this.aBeweise.length; i++){
      this.aBeweise[i].datetime = manualdate;
      //console.log(this.aBeweise[i]);
      
    }
   return true;

}//ueUpload
  public cancelKontrolle(){

    return new Promise(resolve => {
      let params = JSON.stringify({kontid:this.kont.kontid, token: this.userData.jwt});    

      this.http.post(this.common.baseurl+'kontrollen/cancel',params)
        .subscribe(data => {
          let response = data.json();
          if(response.success === true){
              resolve(true);
          }
          else{  
            this.kont.error = response.message;
            resolve(false);  
          }
        //resolve([this.data]);          
        }, error => {
          resolve(false);  
      });
    });       
  }

  public uploadBeweis() {
      var fileTransfer = new FileTransfer();
      var promiseArray = [];
      var randomstring = this.common.random(10);
      for(let i=0; i<this.aBeweise.length; i++){
        
        //-- Upload Foto Auto -------
        let options = {
            fileKey: "file",
            fileName: this.kont.kontid+"_"+randomstring+"_"+(i+1)+".jpg",
            chunkedMode: false,
            mimeType: "image/jpeg",
            params:{
              datum: this.aBeweise[i].datetime,
              kontid: this.kont.kontid,
              fileno: this.aBeweise[i].beweisno
            }
        };

        promiseArray[i] = new Promise(
            function (resolve, reject) {
              console.log(this.aBeweise[i].filename);
                fileTransfer.upload(this.aBeweise[i].filename,encodeURI(this.common.portalurl+"fileuploadkont.php"),
                (function(result){
                  //success
                  let response = JSON.parse(result.response);
                  if(response.success){
                    var i = this.aBeweise.findIndex(i => i.beweisno === response.fileno);    
                    //remove uploaded kontr. bild  
                    this.aBeweise.splice(i,1);               
                    console.log("uppload success");
                    resolve(true);
                  }
                  else{
                    resolve(false);
                  }
                }).bind(this), 
                (function(){
                  //failed
                  console.log("uppload Failed");
                  resolve(false);
                }) ,options);
            }.bind(this)
        );        
        
      }
     return Promise.all(promiseArray);

  }//ueUpload


  finishKont(){
    return new Promise(resolve => {

      this.kont.ende = moment().format();
      let params = JSON.stringify({kont:this.kont, token: this.userData.jwt});
      //console.log(params);    
      this.http.post(this.common.baseurl+'kontrollen/updatenew/'+this.kont.kontid,params)
        .subscribe(data => {
          let response = data.json();
          this.updateRequired = true;

          if(response.success === true){
              resolve(true);
          }
          else{
            console.log("fehler");
            resolve(false);
          }
        resolve([this.data]);          
        }, error => {
          console.log('HTTP Error, no answer');
          resolve(false);
      });
    });    

  }  
          
  clear(){
    if(this.data!=null){
      this.data.length = 0;
    }
    if(this.searchdata!=null){
      this.searchdata.length = 0;
    }
    this.updateRequired = false;
  }

  load() {
    /*
    console.log('load UE');

    return new Promise(resolve => {
      // We're using Angular Http provider to request the data,
      // then on the response it'll map the JSON data to a parsed JS object.
      // Next we process the data and resolve the promise with the new data.

      if(this.userData.loggedin){

        this.http.get(this.common.baseurl+'bussen/getassigned?token='+this.userData.jwt).subscribe(res => {
          this.data = res.json().data;
          this.updateRequired = false;
          
          resolve("");
        }, error => {
          console.log('HTTP Error, no answer ue-data.ts');
          console.log(error);
      });

      }
    });
    */
  }

  search(searchQuery) {
/*
    return new Promise(resolve => {
      if(this.userData.loggedin){
        this.http.get(this.common.baseurl+'bussen/search?searchQuery='+searchQuery+'&token='+this.userData.jwt).subscribe(res => {
          this.searchdata = res.json().data;
          this.updateRequired = false;
          resolve("");
        }, error => {
          console.log('HTTP Error, no answer search ue-data.ts');
          console.log(error);
      });

      }
    });
    */
  }



}



// WEBPACK FOOTER //
// ./src/pages/kontrollen/kontrollen-data.ts